import { Component, Input, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AdminFileManagementUploadComponent } from "../admin-file-management-upload/admin-file-management-upload.component";
import { AdminFileGet, AdminFileType, GasTaxGet } from '../../../../core/interfaces/file-management-interfaces';
import { CommonModule } from '@angular/common';
import { FileManagementService } from '../../../../core/api/file-management.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { IsoToFormattedDatePipe } from "../../../../core/pipes/iso-to-formatted-date.pipe";
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-admin-gas-taxes-files',
  standalone: true,
  imports: [TranslocoPipe, AdminFileManagementUploadComponent, CommonModule, IsoToFormattedDatePipe],
  templateUrl: './admin-gas-taxes-files.component.html',
  styleUrl: './admin-gas-taxes-files.component.css'
})
export class AdminGasTaxesFilesComponent implements OnInit {
  constructor(private fileManagement: FileManagementService, private apiError: ApiErrorService) { }
  AdminFileType = AdminFileType;
  @Input() toast?: ToastComponent;

  gasTaxFiles: AdminFileGet[] = [];

  ngOnInit(): void {
    this.loadGasTaxes();
  }

  loadGasTaxes() {
    this.fileManagement.getGasTaxes().subscribe({
      next: (response) => {
        if (response) {
          this.gasTaxFiles = [];
          this.gasTaxFiles = response;
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }
        this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      },
      complete: () => {
      }
    });
  }

  async getFileManagementFileUrl(fileId: string) {
    try {
      var response = await lastValueFrom(this.fileManagement.downloadFile(fileId));
      return response.download_url;

    } catch (error) {
      var crid = 'UNKNOWN-CRID';

      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
    }
    return null;
  }

  async downloadFile(fileId: string) {
    const fileUrl = await this.getFileManagementFileUrl(fileId || '');
    if (fileUrl) {
      window.open(fileUrl, '_blank');
    }
  }
}
